import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import MainMeta from '../../metaTags/MainMeta';

import ButtonLink from "../../components/Button";
import Slider from "../../components/Slider";

import "../../style/title.scss";
import "./index.scss";

import slider_01 from "../../assets/images/slider_01.webp"
import slider_02 from "../../assets/images/slider_02.webp"
import slider_03 from "../../assets/images/slider_03.webp"
import slider_04 from "../../assets/images/slider_04.webp"
import slider_05 from "../../assets/images/slider_05.webp"
import slider_06 from "../../assets/images/slider_06.webp"

function Home(){
  const { t } = useTranslation();
  const { lang } = useParams(); 
  const images = [
    slider_01,
    slider_06,
    slider_03,
    slider_02,
    slider_04,
  ];
  
  return(
        <div className="home-wrapper">
          <MainMeta />
          <div className='title'>
              <div className='text big'>{t('borscht')}</div>
              <div className='text desktop'>{t('title')}</div>
              <div className='text mobile'><span>{t('title-part1')}</span><span>{t('title-part2')}</span></div>
          </div>
          <Slider images={images} />
          <ButtonLink to={`/${lang}/menu`} className="btn-menu btn-with-borders">
            <span>{t('menu')}</span>
          </ButtonLink>
        </div>
    )
}

export default Home; 